export default "__VITE_ASSET__QHPtF_SY__"